import Image from '@/components/Image';

export default function PostFeaturedImage({ title, image }) {
  return (
    <div className="rounded overflow-hidden">
      <Image src={image.sourceUrl} alt={title} />
    </div>
  );
}
